import React, { useEffect, useState } from "react";
import AppCard from "../../../shared/components/AppCard";
import { Button, Table, Modal, Popconfirm, Tooltip } from "antd";
import {
  EditOutlined,
  DeleteOutlined,
  PlusOutlined,
  FileTextOutlined,
} from "@ant-design/icons";
import "./doctorList.scss";
import { Doctor } from "../../../models/Doctor/doctor.model";
import DoctorForm from "../DoctorForm";
import DoctorService from "../../../services/Doctor/doctor.service";
import AppLoader from "../../../shared/components/AppLoader";
import { AppRoutes } from "../../../routes/routeConstants/appRoutes";
import { generatePath, Link } from "react-router-dom";

interface DoctorListProps {}

function DoctorList(props: DoctorListProps) {
  const [doctors, setDoctors] = useState<Doctor[]>([]);

  const [showDoctorForm, setShowDoctorForm] = useState(false);

  const [activeDoctor, setActiveDoctor] = useState(new Doctor());

  const [loading, setLoading] = useState(false);

  const handleCloseDoctorForm = () => setShowDoctorForm(false);

  const handleAddDoctor = () => {
    setActiveDoctor(new Doctor());
    setShowDoctorForm(true);
  };

  const handleDeleteDoctor = (doctor: Doctor) => {
    // console.log(doctor);
  };

  const handleDoctorFormSuccess = (doctor: Doctor) => {
    setShowDoctorForm(false);
    handleFetchDoctors();
  };

  const handleFetchDoctors = () => {
    setLoading(true);
    DoctorService.fetchDoctors(
      (doctors: Doctor[]) => {
        setDoctors(doctors);
      },
      () => {},
      () => {
        setLoading(false);
      }
    );
  };

  useEffect(() => {
    handleFetchDoctors();
  }, []);

  const columns = [
    {
      title: "Name",
      dataIndex: "doctorName",
      key: "doctorName",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Phone",
      dataIndex: "mobileNumber",
      key: "mobileNumber",
    },
    {
      title: "Assigned today",
      dataIndex: "caseCountForToday",
      key: "caseCountForToday",
    },
    {
      title: "Specialization",
      dataIndex: "specialisation",
      key: "specialisation",
    },
    {
      title: "Action",
      key: "action",
      render: (text: string, doctor: Doctor) => {
        return (
          <div className="doctor-list_actions">
            <Tooltip title="Edit Doctor">
              <EditOutlined
                onClick={() => {
                  setShowDoctorForm(true);
                  setActiveDoctor(doctor);
                }}
              />
            </Tooltip>
            {/* For future use */}
            {/* <Popconfirm
              title="Are you sure to delete this Doctor?"
              placement="left"
              onConfirm={() => {
                handleDeleteDoctor(doctor);
              }}
              okText="Yes"
              cancelText="No"
            >
              <Tooltip title="Delete Doctor">
                <DeleteOutlined />
              </Tooltip>
            </Popconfirm>
            <Tooltip title="View summary">
              <Link
                to={generatePath(AppRoutes.DOCTOR_SUMMARY, {
                  doctorId: doctor?.id,
                })}
              >
                <FileTextOutlined />
              </Link>
            </Tooltip> */}
            {/* For future use */}
          </div>
        );
      },
      width: 150,
    },
  ];

  return (
    <div className="doctor-list">
      <AppCard>
        <h2>
          Doctors
          <Button
            type="primary"
            className="float-right"
            onClick={handleAddDoctor}
          >
            <PlusOutlined />
            Add Doctor
          </Button>
        </h2>
        {loading ? (
          <AppLoader loading={loading} />
        ) : (
          <Table dataSource={doctors} columns={columns} />
        )}
      </AppCard>
      <Modal
        className="primary-modal"
        footer=""
        keyboard={false}
        maskClosable={false}
        destroyOnClose
        visible={showDoctorForm}
        onCancel={handleCloseDoctorForm}
      >
        {activeDoctor && (
          <DoctorForm
            doctor={activeDoctor}
            onSuccess={handleDoctorFormSuccess}
          />
        )}
      </Modal>
    </div>
  );
}

export default DoctorList;
